<template>
    <b-container fluid style="padding:10px">
        <b-jumbotron header="Techstars Blog">
            Where Data and Entrepreneurship intersect.
        </b-jumbotron>
        <b-row align-content center>
            <b-card-group deck v-for="(post,index) in posts" :key="post.slug + '_' + index"
                          class="mb-2 project mx-auto"
            >
                <b-card :title="post.title">

                    <router-link :to="'/blog/' + post.slug">

                        <b-card-img :src=" post.featured_image ">
                        </b-card-img>

                    </router-link>

                    <b-card-body>
<!--                        <b-card-title> {{ post.title }}</b-card-title>-->
                        <b-card-text>
                            {{ post.summary }}
                        </b-card-text>
                    </b-card-body>

                </b-card>
<!--                    <article class="media">-->
<!--                        <figure>-->
<!--                            &lt;!&ndash; Bind results using a `:` &ndash;&gt;-->
<!--                            &lt;!&ndash; Use a `v-if`/`else` if there is a `featured_image` &ndash;&gt;-->
<!--                            <img-->
<!--                                    v-if="post.featured_image"-->
<!--                                    :src="post.featured_image"-->
<!--                                    alt=""-->
<!--                            >-->
<!--                            <img-->
<!--                                    v-else-->
<!--                                    src="http://via.placeholder.com/250x250"-->
<!--                                    alt=""-->
<!--                            >-->
<!--                        </figure>-->
<!--                        <h2>{{ post.title }}</h2>-->
<!--                        <p>{{ post.summary }}</p>-->
<!--                    </article>-->
            </b-card-group>
        </b-row>
    </b-container>
</template>

<script>
    import { butter } from '@/buttercms'
    export default {
        name: 'BlogHome',
        props: ['category'],
        data() {
            return {
                posts: []
            }
        },
        methods: {
            getPosts() {
                butter.post.list({
                    page: 1,
                    page_size: 10,
                    category_slug: this.category
                }).then(res => {
                    this.posts = res.data.data
                })
            }
        },
        created() {
            this.getPosts()
            // alert(this.category)
        }
    }
</script>